<template>
    <common-page card-content flex-column>
        <hazard-common-edit title="隐患问题上报" type="new" @success="whenEditSuccess"></hazard-common-edit>
    </common-page>
</template>

<script>
import HazardCommonEdit from "@/views/mobile/sithMesII/ehs/hazard/HazardCommonEdit.vue";
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";

export default {
    name: "HazardEdit",
    components: {CommonPage, HazardCommonEdit},
    data() {
        return {}
    },
    methods: {
        whenEditSuccess() {
            this.$router.push("/hazard/home");
        },
    }
}
</script>

<style scoped>

</style>
